import React from 'react'
import wikiExternal from '../../image/wikipediaExternalPage.png'
import blogSpot from '../../image/blogspotIcon.jpg'
import funride from '../../lib/funride/funride.module.less'
export default function InnerPageBlog() {
  return (
    <div>
      <header>
        <h1>Blog</h1>
        <p>
          My blog 'Sealed Tuna Sandwich': Postings about technology, software
          development, music, Chicago, politics, and interesting stuff on the
          web.{' '}
          <a
            href="http://gregsandell.blogspot.com"
            rel="noreferrer"
            target="_blank"
          >
            Go to blog
          </a>{' '}
          <img src={wikiExternal} />
        </p>
      </header>
      <a
        href="http://gregsandell.blogspot.com"
        rel="noreferrer"
        target="_blank"
      >
        <img src={blogSpot} />
      </a>
      <dl>
        <dt>Technology-related posts</dt>
        <dd>
          <ul className={funride.singleLines}>
            <li>
              <a
                href="http://gregsandell.blogspot.com/2007/07/maven2-introduction-part-1-coordinate.html"
                rel="noreferrer"
                target="_blank"
              >
                Maven2 Tutorial
              </a>{' '}
              <img src={wikiExternal} />
            </li>
            <li>
              <a
                href="http://gregsandell.blogspot.com/2006/10/s-corps-for-software-contracters.html"
                rel="noreferrer"
                target="_blank"
              >
                S-corps for Software Contracters
              </a>{' '}
              <img src={wikiExternal} />
            </li>
            <li>
              <a
                href="http://gregsandell.blogspot.com/2007/10/sharc-timbre-dataset-v-20-xml-format.html"
                rel="noreferrer"
                target="_blank"
              >
                The SHARC Timbre Dataset v. 2.0: XML Format
              </a>{' '}
              <img src={wikiExternal} />
            </li>
            {/* <li><a */}
            {/*  href='http://gregsandell.blogspot.com/2007/08/idea-with-tomcat-6-integration.html' */}
            {/*  rel='noreferrer' target='_blank'>IDEA with Tomcat 6 Integration */}
            {/*  <img src={wikiExternal} border='0' /></a></li> */}
            {/* <li><a href='http://gregsandell.blogspot.com/2007/07/vista-guinea-pig.html' rel='noreferrer' target='_blank'>Vista */}
            {/*  Guinea Pig */}
            {/*<img src={wikiExternal} border='0' /></a></li> */}
            {/* <li><a */}
            {/*  href='http://gregsandell.blogspot.com/2007/11/zune-surprisingly-enjoyable.html' */}
            {/*  rel='noreferrer' target='_blank'>The Zune, Surprisingly Enjoyable */}
            {/*  <img src={wikiExternal} border='0' /></a></li> */}
            {/* <li><a */}
            {/*  href='http://gregsandell.blogspot.com/2007/08/syncing-handheld-with-vista.html' */}
            {/*  rel='noreferrer' target='_blank'>Syncing a Handheld with Vista */}
            {/*  <img src={wikiExternal} border='0' /></a></li> */}
          </ul>
        </dd>
        <dt>Music-related posts</dt>
        <dd>
          <ul className={funride.singleLines}>
            <li>
              <a
                href="http://gregsandell.blogspot.com/2019/12/zappa-in-memorium.html"
                rel="noreferrer"
                target="_blank"
              >
                Zappa in Memorium
              </a>{' '}
              <img src={wikiExternal} />
            </li>
            <li>
              <a
                href="http://gregsandell.blogspot.com/2019/11/santa-cecilia-orchestra-el-amor-brujo.html"
                rel="noreferrer"
                target="_blank"
              >
                {/* eslint-disable-next-line react/no-unescaped-entities */}
                Santa Cecilia Orchestra: El amor brujo and Mendelssohn
              </a>{' '}
              <img src={wikiExternal} />
            </li>
            <li>
              <a
                href="http://gregsandell.blogspot.com/2018/02/get-to-know-jelly-roll-morton.html"
                rel="noreferrer"
                target="_blank"
              >
                Get To Know Jelly Roll Morton
              </a>{' '}
              <img src={wikiExternal} />
            </li>
            <li>
              <a
                href="http://gregsandell.blogspot.com/2017/12/mahavishnu-returns-royce-hall-ucla-2017.html"
                rel="noreferrer"
                target="_blank"
              >
                Mahavishnu Returns - Royce Hall, UCLA, 2017
              </a>{' '}
              <img src={wikiExternal} />
            </li>
            <li>
              <a
                href="http://gregsandell.blogspot.com/2017/08/remembering-waves.html"
                rel="noreferrer"
                target="_blank"
              >
                Remembering Waves
              </a>{' '}
              <img src={wikiExternal} />
            </li>
            <li>
              <a
                href="http://gregsandell.blogspot.com/2017/02/the-washing-machine.html"
                rel="noreferrer"
                target="_blank"
              >
                The Washing Machine
              </a>{' '}
              <img src={wikiExternal} />
            </li>
          </ul>
        </dd>
      </dl>
    </div>
  )
}
